export const FLEEK_STORAGE_BUCKET = '25710180-23d8-43f4-b0c9-5b7f55f63165-bucket';
export const FLEEK_BASE_URL = 'https://storage.kwenta.io';
